import { render } from "./SideMenu.vue?vue&type=template&id=39edc28d"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WORK\\Vue Project\\inalife-admin-dashboard\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__